export default "__VITE_ASSET__b9b3f4dd__"